import client from 'providers/fetchClient'

export const getAreaTypes = () => client.get('/v3/area-types')

export const createWorkWithUs = data =>
  client.post('/v3/work-with-us', data, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
